module.exports = __webpack_public_path__ + "img/wechat.2d10db9.png";